export enum AppliedProfileTypes {
    WORKFLOW = "workflow",
    IDW = "idw",
    SERVICE = "service",
    TEMPLATE = "template",
    RELYING_PARTY = "rp",
    COMPANY = "company"
}